import React, { useState, useEffect } from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import Link from '@material-ui/core/Link'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import logoSpotter from '../images/logo_spotter-login.png'
import AppStore from '../images/app-store-logo.svg'

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Spotter
      </Link>{' '}
      {new Date().getFullYear()}
    </Typography>
  )
}

export default function DownloadAppPlaceHolder({ title }) {
  const classes = useStyles()
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <img src={logoSpotter} height="120px" alt="spotter"></img>
      </div>
      <div
        style={{
          fontSize: '24px',
          fontWeight: 'bold',
          color: 'white',
          marginTop: '50px',
        }}
      >
        {title}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <a href="https://apps.apple.com/bo/app/spotter/id1571034686">
          <img
            src={AppStore}
            alt="AppStore"
            style={{
              height: '250px',
              width: '250px',
              cursor: 'pointer',
            }}
          ></img>
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.grupoasssets.spotter">
          <img
            alt="Disponible en Google Play"
            src="https://play.google.com/intl/en_us/badges/static/images/badges/es_badge_web_generic.png"
            style={{ width: '250px' }}
          />
        </a>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  )
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))
